import OpticksSvgElement from "@/components/ui/OpticksSvgElement/OpticksSvgElement";
import type { OpticksSvgElementProps } from "@/components/ui/OpticksSvgElement/OpticksSvgElement.types";

// Collection: Tabler Icons
const AnalyzeIcon = ({
  className,
  size = 16,
  "aria-label": ariaLabel,
}: OpticksSvgElementProps) => (
  <OpticksSvgElement
    className={`icon-analyze${className ? ` ${className}` : ""}`}
    size={size}
    aria-label={ariaLabel}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path
      d="M13.3333 7.33333C13.1702 6.16023 12.626 5.07328 11.7844 4.2399C10.9429 3.40652 9.85064 2.87294 8.676 2.72133C7.62699 2.58483 6.56099 2.75963 5.61051 3.22403C4.66004 3.68842 3.86701 4.42191 3.33 5.33333"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.66667 8.66667C2.8209 9.77674 3.31669 10.8113 4.08531 11.627C4.85393 12.4426 5.85729 12.9989 6.95626 13.2187C8.05524 13.4385 9.19537 13.3109 10.2186 12.8536C11.2418 12.3963 12.0974 11.632 12.6667 10.6667"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 10.6667C12 10.8435 12.0702 11.013 12.1953 11.1381C12.3203 11.2631 12.4899 11.3333 12.6667 11.3333C12.8435 11.3333 13.013 11.2631 13.1381 11.1381C13.2631 11.013 13.3333 10.8435 13.3333 10.6667C13.3333 10.4899 13.2631 10.3203 13.1381 10.1953C13.013 10.0702 12.8435 10 12.6667 10C12.4899 10 12.3203 10.0702 12.1953 10.1953C12.0702 10.3203 12 10.4899 12 10.6667Z"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.66667 5.33334C2.66667 5.51015 2.7369 5.67972 2.86193 5.80474C2.98695 5.92977 3.15652 6.00001 3.33333 6.00001C3.51014 6.00001 3.67971 5.92977 3.80474 5.80474C3.92976 5.67972 4 5.51015 4 5.33334C4 5.15653 3.92976 4.98696 3.80474 4.86193C3.67971 4.73691 3.51014 4.66667 3.33333 4.66667C3.15652 4.66667 2.98695 4.73691 2.86193 4.86193C2.7369 4.98696 2.66667 5.15653 2.66667 5.33334Z"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 8C6 8.53043 6.21071 9.03914 6.58579 9.41421C6.96086 9.78929 7.46957 10 8 10C8.53043 10 9.03914 9.78929 9.41421 9.41421C9.78929 9.03914 10 8.53043 10 8C10 7.46957 9.78929 6.96086 9.41421 6.58579C9.03914 6.21071 8.53043 6 8 6C7.46957 6 6.96086 6.21071 6.58579 6.58579C6.21071 6.96086 6 7.46957 6 8Z"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </OpticksSvgElement>
);

export default AnalyzeIcon;
